import { css, unsafeCSS } from 'lit';
import { SizeLrBreakpointMd } from '@laredoute/design-system/tokens';

export const pillStyle = css`
    :host {
        --media-size: '${unsafeCSS(SizeLrBreakpointMd)}';
        --border-color: transparent;
    }
    :host .button {
        --border-size: 1px;
        border: var(--border-size) solid var(--border-color);
        border-radius: 120px;
        column-gap: 0 !important;
    }

    :host([variant='on-light']) .button {
        --border-color: var(--lr-border-secondary-color);
        --background-color: var(--lr-background-secondary);
        --color: var(--lr-color-secondary);
        --border-size: 2px;
    }

    :host([size='small']) .button {
        --padding: 4px 12px;
    }

    :host([size='medium']) .button {
        --padding: 6px 12px;
    }

    :host([size='big']) .button {
        --padding: 8px 12px;
    }
`;
